import React from 'react';

export const ArrowDownSvg: React.FC = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={16}
      height={16}
      fill='none'
    >
      <path
        stroke='#6C6D84'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={1.5}
        d='m4 6 4 4 4-4'
      />
    </svg>
  );
};
